//角色
import Roles from "@/views/systerm/userConfig/role/Roles.vue"; //用户角色配置
import rolesInfo from "@/views/systerm/userConfig/role/rolesInfo.vue";
import rolesUser from "@/views/systerm/userConfig/role/rolesUser.vue";

//权限
import Privs from "@/views/systerm/userConfig/priv/Privs.vue"; //user权限配置/

import privInfo from "@/views/systerm/userConfig/priv/privInfo.vue";
import privRole from "@/views/systerm/userConfig/priv/privRole.vue";
import privUser from "@/views/systerm/userConfig/priv/privUser.vue";

export const UserConfig = [
  {
    path: "/roles",
    name: "roles",
    component: Roles,
    children: [
      {
        name: "rolesInfo",
        path: "",
        redirect: "rolesInfo",
      },
      {
        path: "rolesInfo",
        component: rolesInfo,
      },

      {
        path: "rolesUser",
        component: rolesUser,
      },
    ],
  },
  {
    path: "/privs",
    name: "Privs",
    component: Privs,
    children: [
      {
        name: "privsInfo",
        path: "",
        redirect: "privsInfo",
      },
      {
        path: "privsInfo",
        component: privInfo,
      },
      {
        path: "privsRole",
        component: privRole,
      },
      {
        path: "privsUser",
        component: privUser,
      },
    ],
  },
];
